import { ChevronDown, ChevronUp, ChevronsUpDown } from 'lucide-react';
import { classNames } from '../../utils/classNames';

function SortIcon({ direction }) {
  if (direction === 'asc') return <ChevronUp className="size-4" />;
  if (direction === 'desc') return <ChevronDown className="size-4" />;
  return <ChevronsUpDown className="size-4 opacity-50" />;
}

function Table({ columns, data, rowKey = 'id', sort, onSort, emptyMessage = 'No hay registros para mostrar' }) {
  return (
    <div className="overflow-hidden rounded-card border bg-white">
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-left text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-wide text-content-muted">
            <tr>
              {columns.map((column) => (
                <th key={column.key} className={classNames('whitespace-nowrap px-4 py-3 font-semibold', column.align === 'right' && 'text-right')}>
                  {column.sortable ? (
                    <button type="button" onClick={() => onSort?.(column.key)} className="inline-flex items-center gap-1.5 hover:text-content-primary">
                      {column.header}
                      <SortIcon direction={sort?.key === column.key ? sort.direction : undefined} />
                    </button>
                  ) : column.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y">
            {data.map((row) => (
              <tr key={row[rowKey]} className="transition hover:bg-slate-50/80">
                {columns.map((column) => (
                  <td key={column.key} className={classNames('px-4 py-3.5 text-content-secondary', column.align === 'right' && 'text-right')}>
                    {column.render ? column.render(row[column.key], row) : row[column.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {data.length === 0 && <div className="px-4 py-10 text-center text-sm text-content-muted">{emptyMessage}</div>}
    </div>
  );
}

export default Table;
